/**
 * The presence dot — five states, each one derived from a real signal
 * (spec #44 §4). The colour is meaning, not decoration: green is an agent
 * acting, flame is the owner's moment, a dashed outline is a gate.
 */

import type { PresenceState } from '../../types/workspace';
import styles from './workspace.module.css';

const CLASS: Record<PresenceState, string> = {
  working: styles.dotWorking,
  'needs-you': styles.dotNeedsYou,
  quiet: styles.dotQuiet,
  off: styles.dotOff,
  'not-set-up': styles.dotNotSetUp,
};

export const PRESENCE_LABEL: Record<PresenceState, string> = {
  working: 'Working now',
  'needs-you': 'Needs you',
  quiet: 'Quiet',
  off: 'Off',
  'not-set-up': 'Not set up',
};

export function PresenceDot({ state }: { state: PresenceState }) {
  return (
    <span
      className={`${styles.dot} ${CLASS[state]}`}
      data-testid={`presence-${state}`}
      role="img"
      aria-label={PRESENCE_LABEL[state]}
      title={PRESENCE_LABEL[state]}
    />
  );
}
